<template>
  <div class="edit-reserve-dining-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('editReserveDining.title')" :subtitle="$t('editReserveDining.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="handleCancel">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="saveReserveDiningInfo">
          {{ $t('common.save') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (5) 表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('editReserveDining.title') }}</span>
      </div>

      <el-form ref="form" :model="editReserveDiningInfo" label-width="120px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.goodsName')" prop="goodsName">
              <el-input v-model.trim="editReserveDiningInfo.goodsName" clearable
                :placeholder="$t('editReserveDining.requiredGoodsName')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.params')" prop="paramsId">
              <el-select v-model="editReserveDiningInfo.paramsId" class="w-full"
                :placeholder="$t('editReserveDining.requiredParams')">
                <el-option v-for="(item, index) in editReserveDiningInfo.reserveParamss" :key="index"
                  :label="item.name" :value="item.paramsId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.price')" prop="price">
              <el-input v-model.trim="editReserveDiningInfo.price" clearable
                :placeholder="$t('editReserveDining.requiredPrice')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.sort')" prop="sort">
              <el-input v-model.trim="editReserveDiningInfo.sort" clearable
                :placeholder="$t('editReserveDining.requiredSort')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.startDate')" prop="startDate">
              <el-date-picker v-model="editReserveDiningInfo.startDate" type="datetime" class="w-full"
                value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('editReserveDining.requiredStartDate')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.endDate')" prop="endDate">
              <el-date-picker v-model="editReserveDiningInfo.endDate" type="datetime" class="w-full"
                value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('editReserveDining.requiredEndDate')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.coverImage')" prop="imgUrl">
              <upload-image-url ref="uploadImage" :limit="1"
                :default-images="[editReserveDiningInfo.imgUrl]"
                @notifyUploadCoverImage="handleImageChange" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveDining.state')" prop="state">
              <el-select v-model="editReserveDiningInfo.state" class="w-full"
                :placeholder="$t('editReserveDining.requiredState')">
                <el-option :label="$t('editReserveDining.stateNotOnShelf')" value="1001" />
                <el-option :label="$t('editReserveDining.stateOnShelf')" value="2002" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('editReserveDining.goodsDesc')" prop="goodsDesc">
              <el-input v-model="editReserveDiningInfo.goodsDesc" type="textarea" :rows="3"
                :placeholder="$t('editReserveDining.requiredGoodsDesc')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('editReserveDining.content')" prop="content">
              <div class="editor-wrapper">
                <rich-text-editor ref="richTextEditor" v-model="editReserveDiningInfo.content" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- (7) 底部操作条 -->
      <div class="ds-form-actions">
        <el-button type="warning" @click="handleCancel">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click="saveReserveDiningInfo">
          {{ $t('common.save') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from '@/components/editor/RichTextEditor'
import { updateReserveGoods, listReserveParams, listReserveGoods } from '@/api/scm/editReserveDiningApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'EditReserveDining',
  components: {
    UploadImageUrl,
    RichTextEditor,
    DsPageHeader
  },
  data() {
    return {
      editReserveDiningInfo: {
        goodsId: '',
        goodsName: '',
        goodsDesc: '',
        type: '1001',
        paramsId: '',
        price: '',
        sort: '',
        state: '',
        startDate: '',
        endDate: '',
        imgUrl: '',
        catalogId: '',
        content: '',
        reserveParamss: [],
        communityId: getCommunityId()
      }
    }
  },
  created() {
    this.editReserveDiningInfo.goodsId = this.$route.query.goodsId
    this.listReserveParamss()
    this.listReserveDinings()
  },
  methods: {
    handleImageChange(images) {
      this.editReserveDiningInfo.imgUrl = images.length > 0 ? images[0] : ''
    },
    validateForm() {
      if (!this.editReserveDiningInfo.goodsName) {
        this.$message.error(this.$t('editReserveDining.validate.goodsName'))
        return false
      }
      if (!this.editReserveDiningInfo.paramsId) {
        this.$message.error(this.$t('editReserveDining.validate.paramsId'))
        return false
      }
      if (!this.editReserveDiningInfo.price) {
        this.$message.error(this.$t('editReserveDining.validate.price'))
        return false
      }
      if (!this.editReserveDiningInfo.sort) {
        this.$message.error(this.$t('editReserveDining.validate.sort'))
        return false
      }
      if (!this.editReserveDiningInfo.startDate) {
        this.$message.error(this.$t('editReserveDining.validate.startDate'))
        return false
      }
      if (!this.editReserveDiningInfo.endDate) {
        this.$message.error(this.$t('editReserveDining.validate.endDate'))
        return false
      }
      if (!this.editReserveDiningInfo.imgUrl) {
        this.$message.error(this.$t('editReserveDining.validate.imgUrl'))
        return false
      }
      if (!this.editReserveDiningInfo.state) {
        this.$message.error(this.$t('editReserveDining.validate.state'))
        return false
      }
      if (!this.editReserveDiningInfo.goodsDesc) {
        this.$message.error(this.$t('editReserveDining.validate.goodsDesc'))
        return false
      }
      if (!this.editReserveDiningInfo.content) {
        this.$message.error(this.$t('editReserveDining.validate.content'))
        return false
      }
      return true
    },
    async saveReserveDiningInfo() {
      if (!this.validateForm()) {
        return
      }

      try {
        const res = await updateReserveGoods(this.editReserveDiningInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(this.$t('common.saveError'))
      }
    },
    async listReserveParamss() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.editReserveDiningInfo.communityId
        }
        const res = await listReserveParams(params)
        this.editReserveDiningInfo.reserveParamss = Array.isArray(res.data) ? res.data : []
      } catch (error) {
        console.error('获取参数列表失败:', error)
        this.$message.error(this.$t('editReserveDining.fetchParamsError'))
      }
    },
    async listReserveDinings() {
      try {
        const params = {
          page: 1,
          row: 1,
          goodsId: this.editReserveDiningInfo.goodsId,
          communityId: this.editReserveDiningInfo.communityId
        }
        const res = await listReserveGoods(params)
        if (res.data && res.data.length > 0) {
          Object.assign(this.editReserveDiningInfo, res.data[0])
          this.$refs.richTextEditor.setContent(this.editReserveDiningInfo.content)
          this.$refs.uploadImage.setImages([this.editReserveDiningInfo.imgUrl])
        }
      } catch (error) {
        console.error('获取就餐信息失败:', error)
        this.$message.error(this.$t('editReserveDining.fetchGoodsError'))
      }
    },
    handleCancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-reserve-dining-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.editor-wrapper {
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-sm);
}

.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-md);
  padding-top: var(--ds-spacing-lg);
  margin-top: var(--ds-spacing-lg);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
